module.exports = __webpack_public_path__ + "img/sunny.7f93fbdb.svg";